import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,[_c(VCol,{attrs:{"cols":"12","sm":"6","md":"4"}},[_c(VList,[_c('show-field',{attrs:{"value":_vm.item.locality,"label":_vm.$t('maps.locality.labels.locality'),"icon":"description"}})],1)],1),_c(VCol,{attrs:{"cols":"12","sm":"6","md":"4"}},[_c(VList)],1),_c(VCol,{attrs:{"cols":"12","sm":"6","md":"4"}},[_c(VList)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }